export default __webpack_public_path__ + "static/media/icon-torus.c195727c.svg";